module.exports = __webpack_public_path__ + "7657144ec477cd61ac4a5d1af3fa2d28.woff";